// gavion.email.consent.* — consent chip/dialog and lead-page sequence enrolments (Task 17).
export const consentMessages = {
  fr: {
    title: "Consentement courriel",
    none: "Aucun consentement",
    no_email: "Aucune adresse courriel",
    until: "jusqu'au %{date}",
    no_expiry: "sans expiration",
    expired: "Expiré le %{date}",
    add: "Ajouter un consentement",
    bases: {
      express: "Exprès",
      implied_conspicuous_publication: "Publication bien en vue",
      implied_existing_relationship: "Relation d'affaires existante",
      implied_inquiry: "Demande de renseignements",
    },
    basis: "Base",
    evidence: "Preuve",
    required: "requis",
    evidence_placeholder: "Accepté au téléphone le 2026-10-14 par Martin",
    date: "Date",
    expires_preview: "Expire le %{date}",
    submit: "Enregistrer le consentement",
    saved: "Consentement enregistré.",
    cancel: "Annuler",
    // GAVION campaign-fixes: « Adresse publiée » (bulk and single, admins)
    publication: {
      action: "Consentement « adresse publiée »",
      title: "Consentement implicite « adresse publiée »",
      intro:
        "1 compagnie sélectionnée. |||| %{smart_count} compagnies sélectionnées.",
      explain:
        "Enregistre la base « Publication bien en vue » (LCAP) pour le courriel de la compagnie. Les adresses désabonnées ou supprimées sont ignorées, un consentement déjà valide est gardé tel quel, et une adresse marquée « aucun consentement » n'est jamais remplacée.",
      reminder_title: "Rappel LCAP",
      reminder:
        "Ce consentement implicite ne vaut que si l'adresse est publiée bien en vue (site web, fiche Google, annuaire) sans mention refusant les messages non sollicités, et si vos courriels portent sur les activités de cette compagnie.",
      source: "Source de l'adresse",
      sources: {
        company_website: "Site web de la compagnie",
        google_listing: "Fiche Google",
        directory: "Annuaire",
      },
      url: "Lien vers la page (facultatif)",
      url_invalid: "Le lien doit commencer par https:// ou http://.",
      submit: "Enregistrer",
      done: "Consentement : %{recorded} enregistré(s), %{skipped} déjà valide(s), %{suppressed} supprimé(s), %{refused} refusé(s) (« aucun consentement » déjà inscrit), %{no_email} sans courriel.",
    },
    // GAVION video-campaign: « Ajouter à la campagne » on the compagnies list
    campaign: {
      action: "Ajouter à la campagne",
      title: "Ajouter à la campagne",
      intro:
        "1 compagnie sélectionnée. |||| %{smart_count} compagnies sélectionnées.",
      explain:
        "Chaque compagnie est inscrite avec son courriel (sinon celui de son premier contact) et reçoit les courriels depuis l'Outlook de son représentant. Les compagnies sans consentement valide, désabonnées, sans représentant actif ou dont le représentant n'a pas connecté Outlook ne sont pas inscrites.",
      rep_note:
        "Seules vos compagnies (celles qui vous sont assignées) sont inscrites.",
      sequence: "Campagne (séquence)",
      choose: "Choisir une campagne",
      none: "Aucune campagne active. Un administrateur doit d'abord activer la séquence.",
      submit: "Inscrire",
      close: "Fermer",
      result_title: "Résultat",
      results: {
        enrolled: "Inscrites",
        already: "Déjà inscrites ou l'ayant déjà reçue",
        status:
          "Statut exclu (Ne pas appeler, Client, Pas intéressé, Démo réservée, En pipeline)",
        noEmail: "Sans courriel",
        suppressed: "Désabonnées ou supprimées",
        noConsent: "Sans consentement valide",
        noRep: "Sans représentant actif",
        notConnected: "Représentant non connecté à Outlook",
        notOwn: "Pas vos compagnies",
        failed: "Erreurs",
      },
      done: "%{enrolled} compagnie(s) inscrite(s) à la campagne.",
    },
    sequences: {
      title: "Séquences actives",
      none: "Aucune séquence active",
      next: "Prochaine étape le %{date}",
      remove: "Retirer",
      removed: "Compagnie retirée de la séquence.",
      add: "Ajouter à une séquence",
      sequence: "Séquence",
      choose: "Choisir une séquence",
      email: "Courriel",
      submit: "Inscrire",
      enrolled: "Compagnie inscrite à la séquence.",
      already: "Déjà inscrit à cette séquence",
      status: "Statut : %{status}",
      stop_reason: "Raison d'arrêt : %{reason}",
      auto_enrolled: "Inscrit automatiquement",
      stop_reasons: {
        removed: "Retiré manuellement",
        replied: "A répondu",
        unsubscribed: "Désabonné",
        bounced: "Rebond",
        completed: "Séquence terminée",
        not_interested: "Pas intéressé",
        demo_booked: "Démo réservée",
        in_pipeline: "En pipeline",
        deal_created: "Deal créé",
      },
      statuses: {
        active: "Active",
        stopped: "Arrêtée",
        completed: "Terminée",
        paused: "En pause",
      },
    },
  },
  en: {
    title: "Email consent",
    none: "No consent",
    no_email: "No email address",
    until: "until %{date}",
    no_expiry: "no expiry",
    expired: "Expired on %{date}",
    add: "Add consent",
    bases: {
      express: "Express",
      implied_conspicuous_publication: "Conspicuous publication",
      implied_existing_relationship: "Existing business relationship",
      implied_inquiry: "Inquiry",
    },
    basis: "Basis",
    evidence: "Evidence",
    required: "required",
    evidence_placeholder: "Agreed by phone on 2026-10-14 with Martin",
    date: "Date",
    expires_preview: "Expires on %{date}",
    submit: "Save consent",
    saved: "Consent saved.",
    cancel: "Cancel",
    // GAVION campaign-fixes: « Published address » (bulk and single, admins)
    publication: {
      action: "« Published address » consent",
      title: "Implied consent « published address »",
      intro: "1 lead selected. |||| %{smart_count} leads selected.",
      explain:
        "Records the basis « Conspicuous publication » (CASL) for the lead's company email. Unsubscribed or suppressed addresses are skipped, a consent that is already valid is kept as it is, and an address marked « no consent » is never overwritten.",
      reminder_title: "CASL reminder",
      reminder:
        "This implied consent only holds if the address is conspicuously published (website, Google listing, directory) without a statement refusing unsolicited messages, and if your emails relate to that business's activities.",
      source: "Where the address is published",
      sources: {
        company_website: "Company website",
        google_listing: "Google listing",
        directory: "Directory",
      },
      url: "Link to the page (optional)",
      url_invalid: "The link must start with https:// or http://.",
      submit: "Save",
      done: "Consent: %{recorded} recorded, %{skipped} already valid, %{suppressed} suppressed, %{refused} refused (« no consent » already recorded), %{no_email} without email.",
    },
    // GAVION video-campaign: « Add to campaign » on the leads list
    campaign: {
      action: "Add to campaign",
      title: "Add to campaign",
      intro: "1 lead selected. |||| %{smart_count} leads selected.",
      explain:
        "Each lead is enrolled with its email (else its first contact's) and receives the emails from its rep's Outlook. Leads without a valid consent, unsubscribed, without an active rep or whose rep has not connected Outlook are not enrolled.",
      rep_note: "Only your leads (assigned to you) are enrolled.",
      sequence: "Campaign (sequence)",
      choose: "Choose a campaign",
      none: "No active campaign. An admin must enable the sequence first.",
      submit: "Enrol",
      close: "Close",
      result_title: "Result",
      results: {
        enrolled: "Enrolled",
        already: "Already enrolled or already received",
        status:
          "Excluded status (Do not call, Customer, Not interested, Demo booked, In pipeline)",
        noEmail: "No email",
        suppressed: "Unsubscribed or suppressed",
        noConsent: "No valid consent",
        noRep: "No active rep",
        notConnected: "Rep not connected to Outlook",
        notOwn: "Not your leads",
        failed: "Errors",
      },
      done: "%{enrolled} lead(s) enrolled in the campaign.",
    },
    sequences: {
      title: "Active sequences",
      none: "No active sequence",
      next: "Next step on %{date}",
      remove: "Remove",
      removed: "Lead removed from the sequence.",
      add: "Add to a sequence",
      sequence: "Sequence",
      choose: "Choose a sequence",
      email: "Email",
      submit: "Enrol",
      enrolled: "Lead enrolled in the sequence.",
      already: "Already enrolled in this sequence",
      status: "Status: %{status}",
      stop_reason: "Stop reason: %{reason}",
      auto_enrolled: "Enrolled automatically",
      stop_reasons: {
        removed: "Removed manually",
        replied: "Replied",
        unsubscribed: "Unsubscribed",
        bounced: "Bounced",
        completed: "Sequence completed",
        not_interested: "Not interested",
        demo_booked: "Demo booked",
        in_pipeline: "In pipeline",
        deal_created: "Deal created",
      },
      statuses: {
        active: "Active",
        stopped: "Stopped",
        completed: "Completed",
        paused: "Paused",
      },
    },
  },
} as const;
